module.exports = __webpack_public_path__ + "img/u9001.6be88c2b.svg";